var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query, queryAssignedElements } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { debounce } from 'lodash-es';
import { sdsCustomElement } from '../utilities/custom-components';
import { SdsBreadcrumbsDropdown, } from './dropdown/sds-breadcrumbs-dropdown.lit';
import { SdsBreadcrumbsItem } from './item/sds-breadcrumbs-item.lit';
import { BreadcrumbsOverflowManager } from './overflow/breadcrumbs-overflow-manager';
import styles from './sds-breadcrumbs.lit.scss';
/**
 * Represents a breadcrumb navigation component that allows users to keep track of their locations within programs, documents, or websites.
 * The `SdsBreadcrumbs` class manages the rendering of breadcrumb items and dropdowns, as well as handling overflow and user interactions.
 *
 * @fires sds.breadcrumbs.selected - Dispatches a custom event when a breadcrumb item is selected.
 * @tag sds-breadcrumbs
 * @slot - The default slot for adding `SdsBreadcrumbsItem` or `SdsBreadcrumbsDropdown` elements.
 *
 * @example To use the `SdsBreadcrumbs` component in HTML
 * ```html
 * <sds-breadcrumbs>
 *   <sds-breadcrumbs-item href="#first" label="First"></sds-breadcrumbs-item>
 *   <sds-breadcrumbs-item href="#second" label="Second"></sds-breadcrumbs-item>
 *   <sds-breadcrumbs-dropdown label="More">
 *     <sds-cm-item name="Third"></sds-cm-item>
 *     <sds-cm-item name="Fourth"></sds-cm-item>
 *   </sds-breadcrumbs-dropdown>
 *   <sds-breadcrumbs-item href="#current" label="Current Page"></sds-breadcrumbs-item>
 * </sds-breadcrumbs>```
 */
let SdsBreadcrumbs = (() => {
    var _SdsBreadcrumbs_skipTo_accessor_storage, _SdsBreadcrumbs__items_accessor_storage, _SdsBreadcrumbs__navigation_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-breadcrumbs')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _skipTo_decorators;
    let _skipTo_initializers = [];
    let _skipTo_extraInitializers = [];
    let __items_decorators;
    let __items_initializers = [];
    let __items_extraInitializers = [];
    let __navigation_decorators;
    let __navigation_initializers = [];
    let __navigation_extraInitializers = [];
    var SdsBreadcrumbs = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsBreadcrumbs_skipTo_accessor_storage.set(this, __runInitializers(this, _skipTo_initializers, void 0));
            _SdsBreadcrumbs__items_accessor_storage.set(this, (__runInitializers(this, _skipTo_extraInitializers), __runInitializers(this, __items_initializers, void 0)));
            _SdsBreadcrumbs__navigation_accessor_storage.set(this, (__runInitializers(this, __items_extraInitializers), __runInitializers(this, __navigation_initializers, void 0)));
            this._breadcrumbsOverflowManager = __runInitializers(this, __navigation_extraInitializers);
            this.resizeHandler = () => {
                this._breadcrumbsOverflowManager.calculateOverflow();
            };
            this.resizeHandlerDebounced = debounce(() => this.resizeHandler(), 200, {
                trailing: true,
                leading: false,
            });
            this.breadcrumbsClickHandler = (event) => {
                if (event.target instanceof SdsBreadcrumbsItem ||
                    (event.target instanceof SdsBreadcrumbsDropdown && !event.target.disabled)) {
                    this.dispatchBreadcrumbsItemSelected(event.target);
                }
            };
            this.breadcrumbsDropdownSelectedHandler = (event) => {
                const item = event.detail.item;
                if (item) {
                    event.stopPropagation();
                    item.hasAttribute(SdsBreadcrumbs.BREADCRUMBS_IDENTIFIER)
                        ? this.handleThreeDotSelected(item)
                        : this.dispatchBreadcrumbsItemSelected(item);
                }
            };
        }
        /**
         * Link of skip-to-content
         * @attr
         */
        get skipTo() { return __classPrivateFieldGet(this, _SdsBreadcrumbs_skipTo_accessor_storage, "f"); }
        set skipTo(value) { __classPrivateFieldSet(this, _SdsBreadcrumbs_skipTo_accessor_storage, value, "f"); }
        get _items() { return __classPrivateFieldGet(this, _SdsBreadcrumbs__items_accessor_storage, "f"); }
        set _items(value) { __classPrivateFieldSet(this, _SdsBreadcrumbs__items_accessor_storage, value, "f"); }
        get _navigation() { return __classPrivateFieldGet(this, _SdsBreadcrumbs__navigation_accessor_storage, "f"); }
        set _navigation(value) { __classPrivateFieldSet(this, _SdsBreadcrumbs__navigation_accessor_storage, value, "f"); }
        render() {
            return html `
            ${this.renderSkipToContent()}
            <ol id="navigation" class="${SdsBreadcrumbs.getClasses()}" aria-label="Breadcrumbs">
                <slot></slot>
            </ol>
        `;
        }
        renderSkipToContent() {
            if (this.skipTo) {
                return html `
                <sds-skip-to-content
                    label="Skip Breadcrumbs"
                    target-id="${this.skipTo}"
                ></sds-skip-to-content>
            `;
            }
        }
        connectedCallback() {
            super.connectedCallback();
            this.addLoadHandler();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.removeLoadHandler();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        async firstUpdated() {
            await this.updateComplete;
            this.disableLastBreadcrumbs();
            this.setIdentifiers();
            this.initBreadcrumbsOverflowManager();
            this.addHandlers();
        }
        static getClasses() {
            return classMap({
                'sds-breadcrumbs': true,
            });
        }
        disableLastBreadcrumbs() {
            this._items[this._items.length - 1].disabled = true;
        }
        setIdentifiers() {
            this._items.forEach((item, index) => item.setAttribute(SdsBreadcrumbs.IDENTIFIER, index.toString()));
        }
        initBreadcrumbsOverflowManager() {
            this._breadcrumbsOverflowManager = new BreadcrumbsOverflowManager(this._items, this._navigation, this);
            this.resizeHandlerDebounced();
        }
        addHandlers() {
            this.addResizeHandler();
            this.addLoadHandler();
            this.addBreadcrumbsClickHandler();
            this.addBreadcrumbsDropdownSelectedHandler();
        }
        addResizeHandler() {
            window.addEventListener('resize', this.resizeHandlerDebounced);
        }
        addLoadHandler() {
            window.addEventListener('load', this.resizeHandler);
        }
        addBreadcrumbsClickHandler() {
            this.addEventListener('click', this.breadcrumbsClickHandler);
        }
        addBreadcrumbsDropdownSelectedHandler() {
            this.addEventListener(SdsBreadcrumbsDropdown.BREADCRUMBS_DROPDOWN_ITEM_SELECTED, this.breadcrumbsDropdownSelectedHandler);
        }
        handleThreeDotSelected(item) {
            const selectedIdentifier = item.getAttribute(SdsBreadcrumbs.BREADCRUMBS_IDENTIFIER);
            const selectedItem = this._items.find(item => item.getAttribute(SdsBreadcrumbs.IDENTIFIER) === selectedIdentifier);
            if (selectedItem) {
                this.dispatchBreadcrumbsItemSelected(selectedItem);
            }
        }
        dispatchBreadcrumbsItemSelected(value) {
            this.dispatchEvent(new CustomEvent(SdsBreadcrumbs.BREADCRUMBS_SELECTED, {
                detail: {
                    value: value,
                },
                bubbles: false,
            }));
        }
        removeLoadHandler() {
            window.removeEventListener('load', this.resizeHandler);
        }
    };
    _SdsBreadcrumbs_skipTo_accessor_storage = new WeakMap();
    _SdsBreadcrumbs__items_accessor_storage = new WeakMap();
    _SdsBreadcrumbs__navigation_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsBreadcrumbs");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _skipTo_decorators = [property({ type: String, attribute: 'skip-to' })];
        __items_decorators = [queryAssignedElements()];
        __navigation_decorators = [query('#navigation')];
        __esDecorate(_classThis, null, _skipTo_decorators, { kind: "accessor", name: "skipTo", static: false, private: false, access: { has: obj => "skipTo" in obj, get: obj => obj.skipTo, set: (obj, value) => { obj.skipTo = value; } }, metadata: _metadata }, _skipTo_initializers, _skipTo_extraInitializers);
        __esDecorate(_classThis, null, __items_decorators, { kind: "accessor", name: "_items", static: false, private: false, access: { has: obj => "_items" in obj, get: obj => obj._items, set: (obj, value) => { obj._items = value; } }, metadata: _metadata }, __items_initializers, __items_extraInitializers);
        __esDecorate(_classThis, null, __navigation_decorators, { kind: "accessor", name: "_navigation", static: false, private: false, access: { has: obj => "_navigation" in obj, get: obj => obj._navigation, set: (obj, value) => { obj._navigation = value; } }, metadata: _metadata }, __navigation_initializers, __navigation_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsBreadcrumbs = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.IDENTIFIER = 'identifier';
    _classThis.BREADCRUMBS_IDENTIFIER = 'breadcrumbs-identifier';
    _classThis.BREADCRUMBS_SELECTED = 'sds.breadcrumbs.selected';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsBreadcrumbs = _classThis;
})();
export { SdsBreadcrumbs };
